// Формы оплаты для селекта

export const formPaymentData = [
	{ value: 1, label: 'Наличные' },
	{ value: 2, label: 'Безнал' },
	{ value: 3, label: 'Раздельная' },
];

export const formPaymentSubData = [
	{ value: 1, label: 'Наличные' },
	{ value: 2, label: 'Безнал' },
	{ value: 3, label: 'Раздельная' },
];

// { value: 3, label: 'Раздельная' }